import { useWatch } from 'react-hook-form';
import { useContractor } from '@/composables/useContractor.js';
import { TextInput, useTranslate, required } from 'react-admin';

export const requiredOperators = ['Kaucja', 'Reselekt'];
export const OperatorPointIdInput = ({ source = 'operatorPointId', operatorSource = 'operator' }) => {
    const { contractorId } = useContractor();
    const operator = useWatch({ name: operatorSource });
    const translate = useTranslate();

    return (
        requiredOperators.includes(operator) && (
            <TextInput
                name={source}
                source={source}
                label={translate('resources.collectionPoint.labels.collectionPointId')}
                fullWidth
                disabled={!contractorId}
                validate={required(translate('ra.validation.required'))}
            />
        )
    );
};
